import React, { useState } from 'react'
import clsx from 'clsx'
import './index.scss'

interface ToggleSelectorProps {
    mainColor: boolean
    onClick: (e: any) => void
    option1: string
    option2: string
    checkedSecondOption?: boolean
    disabled?: boolean
}

const ToggleSelector = ({
    mainColor,
    onClick,
    option1,
    option2,
    checkedSecondOption,
    disabled,
}: ToggleSelectorProps) => {
    const [isChecked, setIsChecked] = useState(checkedSecondOption || false)
    const [isSomeChecked, setIsSomeChecked] = useState(false)

    const allCheckedToggle = () => {
        if (isSomeChecked) {
            setIsSomeChecked(false)
            setIsChecked(true)
            return
        }
        const nextChecked = !isChecked
        setIsChecked(nextChecked)
        onClick(nextChecked ? option2 : option1)
    }

    const classNames = clsx(
        'toggle-selector-component',
        mainColor ? 'main-color-set' : 'second-color-set',
        disabled && 'disabled'
    )

    return (
        <div
            className={classNames}
            onClick={!disabled ? allCheckedToggle : () => {}}
            data-testid="toggle-label-component"
        >
            <span className="toggle-option small">{option1}</span>
            <div className={clsx('toggle-wrapper small', isChecked && 'checked')} />
            <span className="toggle-option small">{option2}</span>
        </div>
    )
}

export default ToggleSelector
